<template>
    <div>
        <h3 class="color-light">{{ title }}</h3>
        <div class="resume-item" v-for="(exper_for, index) in exper_for" :key="index">
            <div class="year color-darker">{{ exper_for.debut }} - {{ exper_for.fin }}</div>
            <div class="resume-description">
                <strong class="color-light"> {{ exper_for.ecole }} : {{ exper_for.diplome }}</strong>
            </div>
            <div v-for="(options, index) in exper_for.options" :key="index" > {{ options }} </div>
        </div>
        <div class="resume-item" v-for="(exper_pro, index) in exper_pro" :key="index">
            <div class="year color-darker">{{ exper_pro.debut }} - {{ exper_pro.fin }}</div>
            <div class="resume-description">
                <strong class="color-light"> {{ exper_pro.entreprise }} : {{ exper_pro.poste }} </strong>
            </div>
            <div class="color-darker" v-html="exper_pro.description"></div>
        </div>
    </div>
</template>

<script>export default {
  name: "Traitement",
  props: ["exper_for", "exper_pro", "title"],
};</script>

<style scoped lang="scss">
    .resume-item {
        margin-bottom: 25px;

        p {
            font-size: 1.5rem;
            margin-top: 0;
        }

        .resume-description {
            font-size: 1rem;
        }

        .year {
            font-weight: 600;
            margin-bottom: 5px;
        }
    }
</style>
